import React from 'react'
import styles from './MicrositePlanBanner.module.css'
import { AlertTriangle } from 'lucide-react'

/**
 * MicrositePlanBanner
 * Warning banner shown when plan expiry is within 30 days —
 * extracted from MicrositeDashboard's inline version for reuse.
 *
 * Usage:
 *   <MicrositePlanBanner daysRemaining={12} />
 */
const MicrositePlanBanner = ({ daysRemaining }) => {
    if (daysRemaining === null || daysRemaining === undefined || daysRemaining > 30) return null

    return (
        <div className={styles.banner}>
            <AlertTriangle size={16} />
            <span>
                Your plan expires in <strong>{daysRemaining} day{daysRemaining === 1 ? '' : 's'}</strong>.
                Renew soon to keep your microsite live without interruption.
            </span>
        </div>
    )
}

export default MicrositePlanBanner